<template>
  <div id="contenedor-main-listado-fallo">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :licitacionParticipantes="licitacionParticipantes"></desktop>
    </template>
    <template v-else>
      <mobile></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoFallo',
  props: {
    licitacionParticipantes: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
